import dynamic from 'next/dynamic';
export const SvgIcon = dynamic(() => import('./Icon/SvgIcon'));
export default SvgIcon;
export const EFAdd = dynamic(() => import('./Icon/EFAdd'));
export const EFRed = dynamic(() => import('./Icon/EFRed'));
export const EFReduce: any = dynamic(() => import('./Icon/EFReduce'));
export const EFAddNew: any = dynamic(() => import('./Icon/EFAddNew'));
export const EFArrarRight = dynamic(() => import('./Icon/EFArrarRight'));
export const EFRightOutlined = dynamic(() => import('./Icon/EFRightOutlined'));
export const EFfb = dynamic(() => import('./Icon/EFfb'));
export const EFtw = dynamic(() => import('./Icon/EFtw'));
export const EFins = dynamic(() => import('./Icon/EFins'));
export const EFnofollow = dynamic(() => import('./Icon/EFnofollow'));
export const EFNaver = dynamic(() => import('./Icon/EFNaver'));
export const EFfbHover = dynamic(() => import('./Icon/EFfbHover'));
export const EFtwHover = dynamic(() => import('./Icon/EFtwHover'));
export const EFinsHover = dynamic(() => import('./Icon/EFinsHover'));
export const EFnofollowHover = dynamic(() => import('./Icon/EFnofollowHover'));
export const EFNaverHover = dynamic(() => import('./Icon/EFNaverHover'));
export const EFfbGray = dynamic(() => import('./Icon/EFfbGray'));
export const EFtwGray = dynamic(() => import('./Icon/EFtwGray'));
export const EFinsGray = dynamic(() => import('./Icon/EFinsGray'));
export const EFnofollowGray = dynamic(() => import('./Icon/EFnofollowGray'));
export const EFEmail = dynamic(() => import('./Icon/EFEmail'));
export const EFSearch = dynamic(() => import('./Icon/EFSearch'));
export const EFBilibili = dynamic(() => import('./Icon/EFBilibili'));
export const EFTiktok = dynamic(() => import('./Icon/EFTiktok'));
export const EFWechat = dynamic(() => import('./Icon/EFWechat'));
export const EFWeibo = dynamic(() => import('./Icon/EFWeibo'));
export const EFEarth = dynamic(() => import('./Icon/EFEarth'));
